import React, {Component} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const _separateText = (text) => {
    return (text + '').trim().toLowerCase().split(' ');
};

class PreviewResult extends Component {
    _maxCount = 0;

    render() {
        const texts = this._getTexts();
        const {_maxCount} = this;

        return (
            <div className="PreviewResult text-center">
                {
                    texts.map(({text, count}, index) => {
                        const noTrade = !count;
                        const opacity = (count + _maxCount) / (_maxCount * 2);
                        const style = noTrade ? {} : {opacity};

                        return (
                            <span
                                className={classNames({noTrade})}
                                key={index} style={style}>{text} </span>
                        );
                    })
                }
            </div>
        );
    }

    _getTexts() {
        const {text, texts} = this.props;
        const strings = _separateText(text);

        return strings.map(string => {
            let count = 0;
            const lowerString = (string + '').toLowerCase();

            texts.forEach(t => {
                const ts = _separateText(t);

                if (ts.indexOf(lowerString) !== -1) {
                    count += 1;
                }
            });

            if (count > this._maxCount) {
                this._maxCount = count;
            }

            return {
                text: string,
                count,
            };
        });
    }
}

PreviewResult.propTypes = {
    text: PropTypes.string.isRequired,
    texts: PropTypes.array.isRequired
};

export default PreviewResult;


// WEBPACK FOOTER //
// ./src/app/home/PreviewResult.js